module.exports = __webpack_public_path__ + "img/img-hts2.fd619a97.png";